<template>
  <el-main
    v-loading="!chartData"
    element-loading-background="rgba(122, 122, 122, 0.05)"
    style="height:250px;"
  >
    <Bar
      v-if="chartData"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </el-main>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 250
    },
    height: {
      type: Number,
      default: 250
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    },
    chartData: {
      type: Object
    }
  },
  data () {
    return {
      chartOptions: {
        barThickness: 20, // bar的寬度
        plugins: {
          legend: { // 不顯示預設自帶的狀態list
            display: false
          },
          tooltip: { // hover時的tooltip，只顯示為「0.12 kW」
            yAlign: 'bottom',
            callbacks: {
              label: (context, value) => {
                return `${context.formattedValue} ${this.$t('EvCharging.KwhUnit')}`
              },
              title: () => {}
            },
            displayColors: false,
            padding: 10
          }
        },
        scales: { // 不顯示下方背景格線
          y: {
            grid: {
              display: false
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        }
      }
    }
  }
}
</script>
